<template>
  <TableList
    v-rect-loading="loading"
    class="school-management-list"
    row-key="id"
    :titleI18nKey="`${i18nPrefix}.menu`"
    :list-data="schoolManagementList"
    :table-columns="tableColumns"
    :actionBtn="actionBtn"
    :createBtnLabelI18nKey="`${i18nPrefix}.label.addSchool`"
    :pagination="pagination"
    @pagination-change="loadSchoolManagementList"
    @create="handleCreate"
  >
    <template #filter>
      <el-select v-model="search.reviewStatus" filterable @change="handleReviewStatusChange">
        <el-option
          v-for="(item, index) in statusOptionList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </template>
  </TableList>
</template>

<script>
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

const i18nPrefix = 'admin.company.schoolManagement'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: i18nPrefix,
      loading: false,
      schoolManagementList: [],
      actionBtn: {
        view: {
          show: true,
          onclick: this.handleEdit,
          labelI18nKey: `${i18nPrefix}.label.edit`
        }
      },
      search: {
        reviewStatus: false
      },
      pagination: {
        total: 0,
        page: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.schoolChineseName`),
          dataKey: 'tag'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.schoolEnglishName`),
          dataKey: 'en_tag'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.reviewStatus`),
          dataKey: 'review_status',
          formatter: val => this.$t(`${this.i18nPrefix}.reviewStatus.${val ? 'yes' : 'no'}`)
        }
      ]
      return columns
    },
    statusOptionList () {
      return [
        {
          value: true,
          label: this.$t(`${this.i18nPrefix}.reviewStatus.yes`)
        },
        {
          value: false,
          label: this.$t(`${this.i18nPrefix}.reviewStatus.no`)
        }
      ]
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('schoolManagement', ['getSchoolManagementList']),
    async initPage () {
      this.loading = true
      try {
        this.getStatusFromUrl()
        this.handleRouteChange()
        await this.loadSchoolManagementList()
      } finally {
        this.loading = false
      }
    },
    async fetchSchoolManagementList (reload) {
      if (reload) {
        this.pagination.page = 1
        this.pagination.total = 0
      }
      this.handleRouteChange(true)
      const params = {
        review_status: this.search.reviewStatus,
        page: this.pagination.page,
        page_size: this.pagination.pageSize
      }
      this.loading = true
      try {
        const resp = await this.getSchoolManagementList(params)
        if (resp) {
          this.pagination.total = resp.total
          this.schoolManagementList = resp.result || []
        }
      } finally {
        this.loading = false
      }
    },
    async loadSchoolManagementList () {
      this.fetchSchoolManagementList()
    },
    handleCreate () {
      this.$router.push('/v-admin/client-admin/school-management/add')
    },
    handleEdit (row) {
      this.$router.push(`/v-admin/client-admin/school-management/edit/${row.id}`)
    },
    async handleReviewStatusChange () {
      this.fetchSchoolManagementList(true)
    },
    getStatusFromUrl () {
      const reviewStatus = this.$route.query.reviewStatus
      if (reviewStatus) {
        this.search.reviewStatus = reviewStatus === 'true'
      }
    },
    handleRouteChange (isPush) {
      const reviewStatus = this.$route.query.reviewStatus
      if (((reviewStatus || `${this.search.reviewStatus}`) && reviewStatus !== `${this.search.reviewStatus}`)) {
        isPush
          ? this.$router.push({ query: { reviewStatus: this.search.reviewStatus } })
          : this.$router.replace({ query: { reviewStatus: this.search.reviewStatus } })
      }
    }
  },
  watch: {
    $route () {
      this.getStatusFromUrl()
      this.handleRouteChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-company-popper {
  .company-option {
    width: 462px;
  }
}
</style>
